
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[merchantLocationId]/item/[itemId]",
      function () {
        return require("private-next-pages/m/[merchantLocationId]/item/[itemId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[merchantLocationId]/item/[itemId]"])
      });
    }
  